import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { FidelityType } from '../fidelity-type.enum';

@Component({
  selector: 'app-kiosk-confirmation-step',
  template: `
    @if (user$ | async; as user) {
      <div class="flex flex-col items-center justify-center gap-12">
        <h1
          class="w-full text-center text-4xl font-bold"
          [style.color]="accentColor?.font | contentBuilderColor"
        >
          {{
            fidelityType + '.create-or-link-account.kiosk-confirmation-step.title'
              | translate: { firstname: user.firstname ? user.firstname : '' }
          }}
        </h1>
        <i
          class="icon icon-n-check text-9xl"
          [style.color]="accentColor?.font | contentBuilderColor"
        ></i>
        <div class="w-full">
          <app-button-atom
            size="L"
            [label]="
              fidelityType + '.create-or-link-account.kiosk-confirmation-step.continue' | translate
            "
            type="kiosk-primary"
            [overrideTextColor]="accentColor?.font"
            [overrideBgColor]="accentColor?.background"
            (click)="onCompleteStep()"
            [full]="true"
          ></app-button-atom>
        </div>
      </div>
    }
  `,
  standalone: false,
})
export class KioskConfirmationStepComponent {
  @Output() onComplete = new EventEmitter<void>();

  @Input() accentColor?: ContentBuilderFieldColors;
  @Input() fidelityType?: FidelityType;

  user$ = this.authSelector.selectUser$;

  constructor(private readonly authSelector: AuthStoreSelector) {}

  onCompleteStep(): void {
    this.onComplete.next();
  }
}
